import { useSyncExternalStore } from "react";
import { Link } from "react-router-dom";

import { AbcFitnessBrandLogo } from "@/components/portal/AbcFitnessBrandLogo";
import {
  getAuthSessionSnapshot,
  getContactFirstName,
  subscribeAuthSession,
} from "@/lib/auth/session";
import { UserAccountMenu } from "./UserAccountMenu";
import { SkipToContent } from "./SkipToContent";

export function HomeTopNav() {
  const session = useSyncExternalStore(
    subscribeAuthSession,
    getAuthSessionSnapshot,
    getAuthSessionSnapshot,
  );
  const displayName = session ? getContactFirstName(session.user.contact_name) : null;

  return (
    <>
      <SkipToContent />
      <nav
      className="topnav"
      style={{ background: "var(--card)" }}
      data-testid="home-nav"
    >
      <Link className="topnav-logo" to="/" data-testid="home-nav-logo">
        <AbcFitnessBrandLogo to="" theme="light" />
        <span className="logo-badge">Dev Portal</span>
      </Link>

      <div className="nav-right" style={{ gap: 8 }}>
        {displayName ? (
          <UserAccountMenu userName={displayName} testIdPrefix="home-nav" />
        ) : (
          <>
            <Link
              to="/login"
              className="btn btn-outline"
              data-testid="home-nav-login"
            >
              <i className="ti ti-login" aria-hidden /> Log in
            </Link>
            <Link
              to="/signup"
              className="btn btn-outline"
              data-testid="home-nav-signup"
            >
              <i className="ti ti-user-plus" aria-hidden /> Sign up
            </Link>
          </>
        )}
      </div>
    </nav>
    </>
  );
}
